import { Directive, EventEmitter, HostBinding, HostListener, Output, ElementRef, OnInit, OnDestroy } from '@angular/core';
import {CommonService} from "../../services/common.service";
import {ISubscription} from "rxjs/Subscription";

@Directive({
    selector: '[appDraggable]'
})
export class DraggableDirective implements OnInit, OnDestroy {
    @HostBinding('class.draggable') draggable = true;

    public pointerId?: number;
    public subscribe: ISubscription;

    // to trigger pointer-events polyfill
    @HostBinding('attr.touch-action') touchAction = 'none';

    @Output() dragStart = new EventEmitter<PointerEvent>();
    @Output() dragMove = new EventEmitter<PointerEvent>();
    @Output() dragEnd = new EventEmitter<PointerEvent>();

    @HostBinding('class.dragging') dragging = false;

    constructor(public element: ElementRef, public commonService: CommonService) {}

    ngOnInit(){
        this.subscribe = this.commonService.pointerMoveCurrent.subscribe((e: PointerEvent) => e ? this.onPointerMove(e): null);
    }

    ngOnDestroy(){
        this.subscribe.unsubscribe();
    }

    @HostListener('pointerdown', ['$event'])
    onPointerDown(event: PointerEvent): void {
        // added after YouTube video: ignore right-click
        if (event.button !== 0) {
            return;
        }

        this.pointerId = event.pointerId;

        // document.body.style.cursor = 'move';
        this.dragging = true;
        this.dragStart.emit(event);
    }

    //@HostListener('document:pointermove', ['$event'])
    onPointerMove(event: PointerEvent): void {
        if (!this.dragging || event.pointerId !== this.pointerId) {
            return;
        }

        this.dragMove.emit(event);
    }

    // added after YouTube video: pointercancel
    @HostListener('document:pointercancel', ['$event'])
    @HostListener('document:pointerup', ['$event'])
    onPointerUp(event: PointerEvent): void {
        if (!this.dragging || event.pointerId !== this.pointerId) {
            return;
        }

        this.dragging = false;
        // document.body.style.cursor = 'auto';
        this.dragEnd.emit(event);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/draggable.directive.ts